export enum CategoryMutationTypes {
    SET_CATEGORY_LIST = 'SET_CATEGORY_LIST',
    SET_CATEGORY_SELECTED = 'SET_CATEGORY_SELECTED',
    SET_CATEGORY_BREADCRUMB = 'SET_CATEGORY_BREADCRUMB',
}
